import { render, staticRenderFns } from "./pay_config_edit.vue?vue&type=template&id=ea6aae30&scoped=true"
import script from "./pay_config_edit.vue?vue&type=script&lang=ts"
export * from "./pay_config_edit.vue?vue&type=script&lang=ts"
import style0 from "./pay_config_edit.vue?vue&type=style&index=0&id=ea6aae30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6aae30",
  null
  
)

export default component.exports